import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

import {ref, computed, onMounted, onUpdated, onBeforeUnmount} from 'vue';
  import {t} from '../../../bps/utilities/js/translations/translations';
  import scrollToElement from 'scroll-to-element';

  type Props = {
    maxHeight?: number;
    offset?: number;
    textMore?: string;
    textLess?: string;
    scrollLessElement?: string;
  };

  
export default /*@__PURE__*/_defineComponent({
  __name: 'readMore',
  props: {
    maxHeight: { default: 100 },
    offset: { default: 80 },
    textMore: { default: 'bps.components.read_more.read_more' },
    textLess: { default: 'bps.components.read_more.read_less' },
    scrollLessElement: { default: '' }
  },
  setup(__props: any) {

  const props = __props;

  const open = ref(false);
  const elementHeight = ref(0);

  const slotElement = ref<HTMLElement | null>(null);
  const lessButton = ref<HTMLElement | null>(null);

  const disabled = computed(() => {
    return (props.maxHeight ?? 0) >= elementHeight.value || (elementHeight.value - (props.maxHeight ?? 0)) < props.offset;
  });

  const style = computed(() => {
    if (disabled.value) return null;
    return {
      maxHeight: open.value ? 'none' : `${props.maxHeight}px`
    };
  });

  const label = computed(() => {
    const key = open.value ? props.textLess : props.textMore;
    return t(key ?? '');
  });

  function setHeight() {
    const el = slotElement.value;
    if (el) {
      elementHeight.value = el.getBoundingClientRect().height + 30;
    }
  }

  function isElementInViewport(el: HTMLElement | null) {
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    return rect && Math.round(rect.bottom) < 0;
  }

  function toggle() {
    if (disabled.value) return;

    open.value = !open.value;

    if (!open.value && props.scrollLessElement) {
      const item = document.querySelector(props.scrollLessElement);
      const stickyNavigation = document.querySelector('.product-navigation__container');
      let offsetHeight = -10;
      if (stickyNavigation && stickyNavigation.classList.contains('product-navigation__container--sticky')) {
        offsetHeight -= (stickyNavigation as HTMLElement).getBoundingClientRect().height;
      }

      window.setTimeout(() => {
        const lessBtn = lessButton.value;
        if (isElementInViewport(lessBtn)) {
          scrollToElement(item as any, {duration: 400, offset: offsetHeight});
        }
      }, 50);
    }
  }

  onMounted(() => {
    setHeight();
    window.addEventListener('resize', setHeight);
  });

  onUpdated(() => {
    setHeight();
  });

  onBeforeUnmount(() => {
    window.removeEventListener('resize', setHeight);
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["read-more", {
      'read-more--open': open.value,
      'read-more--closed': !open.value,
      'read-more--button-is-visible': !disabled.value
    }])
  }, [
    _createElementVNode("div", {
      class: "read-more__container",
      style: _normalizeStyle(style.value)
    }, [
      _createElementVNode("div", {
        class: "read-more__slot",
        ref_key: "slotElement",
        ref: slotElement
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 512 /* NEED_PATCH */)
    ], 4 /* STYLE */),
    _cache[1] || (_cache[1] = _createTextVNode()),
    (!disabled.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "read-more__btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (toggle())),
          ref_key: "lessButton",
          ref: lessButton
        }, _toDisplayString(label.value), 513 /* TEXT, NEED_PATCH */))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}
}

})